import { SET_PASSWORD } from '../actions/types'

export default function (state = {}, action) {
  switch (action.type) {
    case SET_PASSWORD:
      state = action.payload.data ? action.payload.data : {}
      return state
  }
  return state
}